var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedcityLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 76.5,
    y1: 172.4,
    x2: 97.1,
    y2: 172.1,
    gradientTransform: "matrix(4.46979 0 0 4.46979 -334.4 -735.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64b245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18519f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7 67c-6 11.5-19 18.5-31 19.2-9.7.5-20.3-5.4-26.2-12.7A55.3 55.3 0 0 1 .4 43.8C0 39-.3 34 .4 30.8c.3-1 1.2-3.3 2.9-3.3 2 0 2.2 3.4 2.3 4.6C6 37.6 7.3 43.5 9 49.4 11 55.9 16 61.7 22 65.8c1.1.8 2.6 1.8 3.9 1.3.5-.1.8-.7.8-1.2 0-1.1-1-2-1.8-2.8-2-2.4-4.7-4-7-6.1-1.3-1.4-2.7-2.7-3.9-4.3-.8-1.2-1.9-3-.9-4.4 1.2-1.5 3.8-.3 3.8-.3 3.4 1.5 6.7 4.1 9.8 6.5 4.2 3.3 7.7 7.4 11.9 10.6 3.6 2.8 7 6.1 11.3 7.6 3.5 1.2 7.6 2 11.1.9 3.3-1 6-3.6 8.8-6.6zm0 0",
    fill: "#225aa7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 0c-7 0-14.5 3.4-19.2 8.6a26 26 0 0 0-6.3 20.1c.8 5.6 3.5 11 7.8 15 2.1.4 4.5 1.4 6.5 2.5 4 2.3 7.8 5.4 11.2 8.7 4 3.9 8.4 7.7 12.9 11.3 2.8 2.2 6.3 4.2 9.9 4.3 3 0 6.3-1.1 8.5-3 8.9-8 18.6-14.7 26.7-23.1a29 29 0 0 0 7.9-12.5c1.3-5.3 1-11.4-1-16.5a25.3 25.3 0 0 0-9.4-11c-4-2.7-9-4.1-14-4.2-6.4-.2-13 1-20.8 11A25.4 25.4 0 0 0 33.3 0zm41 5.8c4.2 0 8.5 1.2 12 3.3a18.7 18.7 0 0 1 7 23.9c-1 2.2-2 4.1-6.2 8.1V18.7h-6.3v20.8h-4.5v-8.3h-9.1v10.9h-4.7v-3.7H55V49h-4.7V21.7l-8.7-3.4v22.5H36v-10h-9.7v3.8h-6.1v6.3c-4.2-4-6-8-6.7-12.7-.6-4 .1-8.4 2.1-11.9 2.5-4.2 6.7-8 11.4-9.4 5.2-1.5 11.2-.4 16.1 1.8 4.5 2 7.7 6.8 11 10C59.5 13.4 63.6 8 70 6.3c1.4-.4 2.7-.5 4.2-.5zm0 0",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedcityLogo);
export default __webpack_public_path__ + "static/media/medcity-logo.2fc096ff345791f9e29d6f392195402e.svg";
export { ForwardRef as ReactComponent };